import { Box, Card, Link, Typography, styled } from '@mui/material';

function Footer() {
  return (
    <FooterWrapper className="footer-wrapper">
      <Box p={4} display={{ xs: 'none', md: 'none' }} alignItems="center" textAlign={{ xs: 'center', md: 'left' }} justifyContent="space-between">
        <Box>
          <Typography variant="subtitle1">&copy; 2023 - Bold Webclient</Typography>
        </Box>
        <Typography sx={{ pt: { xs: 2, md: 0 } }} variant="subtitle1">
          by{' '}
          <Link href="#" target="_blank" rel="noopener noreferrer">Dacsa</Link>
        </Typography>
      </Box>
    </FooterWrapper>
  );
}

const FooterWrapper = styled(Card)(
  ({ theme }) => `
        border-radius: 0;
        margin-top: ${theme.spacing(4)};
`
);

export default Footer;
